module.exports = __webpack_public_path__ + "img/no-deadline.73a2ee96.svg";